import React from 'react';
import { Tooltip } from '@mantine/core';

type RiskLevel = 'medium' | 'high';

interface RiskLevelIndicatorProps {
  level: RiskLevel;
}

const LABELS: Record<RiskLevel, string> = {
  medium: 'Medium risk level',
  high: 'High risk level',
};

const COLORS: Record<RiskLevel, string> = {
  medium: 'var(--quo-yellow)',
  high: 'var(--quo-power-75)',
};

const RiskLevelIndicator = ({ level }: RiskLevelIndicatorProps) => (
  <Tooltip label={LABELS[level]}>
    <span
      aria-label={LABELS[level]}
      style={{
        display: 'inline-block',
        width: '0.65em',
        height: '0.65em',
        borderRadius: '50%',
        backgroundColor: COLORS[level],
        verticalAlign: 'middle',
      }}
    />
  </Tooltip>
);

export default RiskLevelIndicator;
